
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { ButtonLink } from '@/components/ui/buttonlink';
import { CalendarDays, Users, Target, TrendingUp, Calendar, BadgeCheck, Megaphone } from 'lucide-react';
import { motion } from 'framer-motion';
import IndustryHeroSection from '@/components/industry/IndustryHeroSection';
import IndustryFeatures from '@/components/industry/IndustryFeatures';
import IndustryTestimonials from '@/components/industry/IndustryTestimonials';
import IndustrySelectionSection from '@/components/industry/IndustrySelectionSection';
import IndustryCTA from '@/components/industry/IndustryCTA';
import { useEffect } from 'react';
import { sendPageView } from '@/services/analyticsService';

const IndustryCalendarSolutions = () => {
  useEffect(() => {
    sendPageView('Szakmai naptárrendszerek');
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <Helmet>
        <title>Szakmai naptárrendszerek minden területre | EventHub</title>
        <meta 
          name="description" 
          content="Egyedi naptárrendszerek minden szakma számára - A sikeres rendezvényszervezés és eseménykezelés modern eszköze. Fedezze fel a lehetőségeket!" 
        />
      </Helmet>
      
      <Navbar />
      
      <main>
        <IndustryHeroSection />
        <IndustrySelectionSection />
        <IndustryFeatures />
        <IndustryTestimonials />
        <IndustryCTA />
      </main>
      
      <Footer />
    </div>
  );
};

export default IndustryCalendarSolutions;
